module.exports = __webpack_public_path__ + "files/73d925bcbfedeaeb3c4fe2b18a4132b3.png";